export default __webpack_public_path__ + "static/media/instagram.abd661ba.svg";